import React, { useState } from "react";
import { Drawer, DrawerContent, useDisclosure } from "@heroui/react";
import ButtonMethodPayment from "../../components/ButtonMethodPayment";
import Invoice from "../../components/Invoice";
import { ReactComponent as Close } from "../../assets/close.svg";
import ButtomSave from "../../components/ButtomSave";
import { InvoiceTypes } from "../../lib/interfaces";
import { isMobile } from "react-device-detect";
import PaymentStatus from "../../components/PaymanetStatus";
import { useStore } from "../../lib/store";
import { AmplitudeLog } from "../../lib/amplitude";
import { HandleShare } from "../..//lib/utils";
import { ScrollArea } from "../../components-shadcn/scroll-area";

type IconKey = "error" | "success" | "processing";

interface Props {
  invoice: InvoiceTypes;
  wide?: boolean;
}

interface TypePaymentStatus {
  open: boolean;
  icon: IconKey;
  title: string;
  legend: string;
}

const PaymentBoletoAreaCliente: React.FC<Props> = ({ invoice, wide }) => {

  const { isOpen, onOpen, onOpenChange } = useDisclosure();

  const { credit_card } = useStore();

  const [texto_copiar, set_texto_copiar] = useState("Copiar código de barra");

  const [status_invoice, set_status_invoice] = useState<TypePaymentStatus>({
    open: false,
    icon: "processing",
    title: "",
    legend: "",
  });

  const { external_link } = useStore();

  const { user } = useStore();

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(invoice.codebar);
      set_texto_copiar("Código de barra copiado!");
    } catch (err) {}
  };

  const handleDownloadInvoice = () => {
    window.parent.postMessage(
      { type: "BOTAO_PRESSIONADO", payload: { url: invoice.url_boleto } },
      "*"
    );
  };

  function handleDownloadInvoiceExternal() {
    console.log("aqui");
    const link = document.createElement("a");
    link.href = invoice.url_boleto;
    link.download = "boleto.pdf";
    link.target = "_blank"; // opcional, para abrir em nova aba se for visualizável
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  const handleReadyPayment = () => {
    AmplitudeLog("Aguardando_boleto_pagamento", { user_id: user });
    set_status_invoice({
      icon: "processing",
      legend: "Aguarde o processamento de até 2 dias úteis do boleto.",
      open: true,
      title: "Pagamento sendo processado",
    });
  };

  return (
    <>
      {isOpen && <div className="fixed inset-0 bg-black/50 z-40" />}
      <ButtonMethodPayment
        onClick={() => {
          AmplitudeLog("Op_boleto_pagamento", { user_id: user });
          onOpen();
        }}
        icon="boleto"
        theme={"white"}
        disabled={invoice?.url_boleto === "" ? true : false}
        wide={wide}
      >
        Pague com Boleto
      </ButtonMethodPayment>
      <Drawer
        isOpen={isOpen}
        onOpenChange={onOpenChange}
        placement={"bottom"}
        hideCloseButton
        onClose={() => {
          set_texto_copiar("Copiar código de barra");
          set_status_invoice({
            icon: "processing",
            legend: "",
            open: false,
            title: "",
          });
        }}
      >
        <DrawerContent
          className={`
          w-full
          rounded-t-[0.75rem]
          ${!isMobile && "!max-h-screen !h-[100vh] !rounded-none !border-none"}
          bg-white-primary px-[2rem] pb-[2rem]
          flex
          items-center
          !max-h-screen
        `}
        >
          {(onClose) => (
            <div
              className={`${external_link && !isMobile ? "w-[60%]" : "w-full"}`}
            >
              <div className="w-[100%] flex justify-end">
                <button
                  onClick={onClose}
                  style={{
                    background: "transparent",
                    border: "none",
                    cursor: "pointer",
                    marginTop: "1.5rem",
                  }}
                >
                  <Close className="w-[1rem] h-[1rem]" />
                </button>
              </div>
              <ScrollArea className="h-[100%]">
                <div className="w-[100%] flex justify-center">
                  <p className="text-blue-primary text-[1.04rem] font-[700]">
                    Pagamento com Boleto
                  </p>
                </div>
                <p className="text-gray-dark text-[1.04rem] mt-[1.44rem] font-[700]">
                  Fatura
                </p>
                <Invoice
                  duedate={invoice?.vencimento}
                  price={invoice?.preco}
                  theme="default"
                />
                <hr />
                <div>
                  <p className="mt-[1.4rem]">
                    Caso deseje a{" "}
                    <strong>liberação imediata do seu acesso</strong>{" "}
                    recomendamos o pagamento por meio de{" "}
                    <strong>Cartão de crédito</strong> <strong>ou Pix.</strong>{" "}
                  </p>
                  <div className="flex flex-col gap-[0.75rem] mt-[2.20rem]">
                    <ButtomSave
                      icon={
                        texto_copiar === "Copiar código de barra"
                          ? "copy"
                          : "none"
                      }
                      theme="mediumgreen"
                      onClick={() => {
                        handleCopy();
                        AmplitudeLog("Copiar_boleto_pagamento", {
                          user_id: user,
                        });
                      }}
                    >
                      {texto_copiar}
                    </ButtomSave>
                    <ButtomSave
                      icon="download"
                      theme="white"
                      onClick={() => {
                        external_link === false
                          ? handleDownloadInvoice()
                          : handleDownloadInvoiceExternal()
                        AmplitudeLog("Baixar_boleto_pagamento", {
                          user_id: user,
                        });
                      }}
                    >
                      Baixar boleto
                    </ButtomSave>
                    {external_link === false && isMobile && (
                      <ButtomSave
                        icon="share"
                        theme="white"
                        onClick={() => {
                          HandleShare(invoice.codebar);
                          AmplitudeLog("Compartilhar_boleto_pagamento", {
                            user_id: user,
                          });
                        }}
                      >
                        Compartilhar
                      </ButtomSave>
                    )}
                  </div>
                  <div className="flex flex-row items-center mt-[1.5rem]">
                    <p className="mr-1">Já fez o pagamento?</p>
                    <p
                      className="underline decoration-solid text-gray-dark"
                      onClick={() => {
                        AmplitudeLog("Pago_boleto_pagamento", {
                          user_id: user,
                        });
                        handleReadyPayment();
                      }}
                    >
                      Clique aqui
                    </p>
                  </div>
                </div>
              </ScrollArea>
              <PaymentStatus
                icon={status_invoice.icon}
                legend={status_invoice.legend}
                open={status_invoice.open}
                title={status_invoice.title}
              />
            </div>
          )}
        </DrawerContent>
      </Drawer>
    </>
  );
};

export default PaymentBoletoAreaCliente;
